import * as auth from '../auth'

export const creditCardsSelector = createSelector(auth.selectors.userSelector, user => (user ? user.creditCards : []))

export const creditCardFormStateSelector = state => state.creditCards
